import React, { useEffect, useState, useContext } from 'react';
import axios from 'axios';
import PatientForm from '../InformationsForms/PatientForm';
import EmployerForm from '../InformationsForms/EmployerForm';
import ReferredByForm from '../InformationsForms/ReferredByForm';
import ProceduresForm from '../InformationsForms/ProceduresForm';
import SpecialInstructions from '../InformationsForms/SpecialInstructions';
import { Button, Row } from 'antd';
import { mainContext } from '../../context/context';
import { baseUrl } from '../../common/constants';
import { toast } from 'react-toastify';
import { useParams } from 'react-router-dom';
import _axios from '../../utils/api/_axios';
import ValidateModal from './ValidateModal';
import styles from './newEntries.module.scss'
import { Content } from 'antd/es/layout/layout';
import { set } from 'react-hook-form';

const ViewDetails = () => {
    const { formDataValues, getFormData, insurenceId, adjusterId } = useContext(mainContext);
    const { id } = useParams();
    const [patientDetails, setPatientDetails] = useState({});
    const [claimId, setClaimId] = useState("");
    const [patients, setPatients] = useState([]);
    const [modal2Visible, setModal2Visible] = useState(false);
    const [selectedData, setSelectedData] = useState({});
    const [selectedClaim, setSelectedClaim] = useState({});
    const [patientId, setPatientID] = useState(null);
    const [message, setMesages]= useState("")
    const [docs,setDocs]=useState([]);

    const fetchEmployeeInfo = async () => {
        try {
            const response = await _axios.get(`${baseUrl}/openAccess/${id}`);
            if(response?.data?.payload?.referredByInfo?.scripts){
                const scriptResponse = await _axios.get(`${baseUrl}/openAccess/getFile/${response?.data?.payload?.referredByInfo?.scripts[0]}`);
                setDocs(scriptResponse?.data?.payload);
            }

            if (response.status === 200) {
                const patientInfo = response.data?.payload?.patientInfo;
                setPatientDetails(patientInfo);
                setClaimId(response?.data?.payload?._id);
                setSelectedData(patientInfo);
                setSelectedClaim(response.data?.payload);
                getFormData(response.data.payload);
            }
            if(response?.data?.payload?.referredByInfo?.scripts !== undefined){
                const scriptResponse = await _axios.get(`${baseUrl}/openAccess/getFile/${response?.data?.payload?.referredByInfo?.scripts[0]}`);
                setDocs(scriptResponse?.data?.payload);
            }
            
        } catch (err) {
            console.log(err);
        }
    };

    const [referredData, setReferredData] = useState({
        insuranceCompany: null,
        adjuster: null,
        adjusters: null,
        insuranceCompanies: null
    });

      function companyAndAdjuster(data) {
        setReferredData(data)
      }
      const handleSubmit = async (e) => {
        e.preventDefault();
        const adjusterName = (firstName, lastName)=>{
            const formattedName = firstName + " " + lastName;
            return formattedName;
        }
        const insuranceExists = referredData?.insuranceCompanies?.some(
          (item) => {
            return (referredData?.insuranceCompany === null) ? item.companyName === formDataValues.insuranceSelectValue: item.id === referredData.insuranceCompany;
          }
        );
        const adjusterExists = referredData?.adjusters?.some(
          (item) => {
           return (referredData?.adjuster === null) ? adjusterName(item.firstName,item.lastName) === formDataValues.adjusterSelectValue: item.id === referredData.adjuster;
          }
        );
        if (!insuranceExists) {
          toast.warning("Selected Insurance Company not found in system.");
          return;
        }
        if (!adjusterExists) {
            toast.warning("Selected Adjuster not found in system.");
            return;
          }
        try {
          const response = await axios.post(
            `${baseUrl}/openAccess/validate/${id}`,
            {
              claimEmail: patientDetails?.email,
              dob: patientDetails?.dateOfBirth,
              claimId: claimId,
            },
            {
              headers: {
                "Content-Type": "application/json",
              },
              cache: "no-cache",
            }
          );
          setPatients(response.data.payload);
          setMesages(response.data.payload?.message);
          if (response?.data.payload) {
            setModal2Visible(true);
          }
        } catch (error) {
          toast.error(error?.response?.data?.metadata?.errorMessage);
        }
      };


    useEffect(() => {
        fetchEmployeeInfo();
    }, []);

    return (
        <Content className={styles.container}>
            <form onSubmit={handleSubmit}>
                <PatientForm />
                <EmployerForm />
                <ReferredByForm 
                    docs={docs} 
                    fetchEmployeeInfo={fetchEmployeeInfo} 
                    companyAndAdjuster={companyAndAdjuster} 
                />
                <ProceduresForm />
                <SpecialInstructions />
                <Row justify={'end'} className={styles.validateWrapper}>
                    <Button htmlType='submit' style={{ width: '50%' }} type='primary'>Validate</Button>
                </Row>
            </form>
            <ValidateModal open={modal2Visible} handleClose={() => setModal2Visible(false)}
            patientsList={patients} selectedData={selectedData} 
            selectedClaim={selectedClaim}
            patientId={patientId}
            setPatientID={setPatientID}
            message={message}
            docs={docs}
            claimId={claimId}
             />
        </Content>
    );
};

export default ViewDetails;

